import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { transformColumnsToFilterFields } from './queries';

export const getGenericListState = (state: RootState) => state.genericList;

export const getGenericListColumns = (state: RootState) =>
  getGenericListState(state).columns.filter((column) => column.visible);

export const getGenericListRowData = (state: RootState) =>
  getGenericListState(state).rows;

export const getGenericListMetaData = (state: RootState) =>
  getGenericListState(state).metaData;

export const getGenericListCurrentPage = (state: RootState) =>
  getGenericListState(state).metaData.currentPage || 1;

export const getGenericListPageSize = (state: RootState) =>
  getGenericListState(state).metaData.pageSize || 50;

export const getGenericListTotalPageCount = (state: RootState) =>
  getGenericListState(state).metaData.totalCount;

export const getGenericListLoading = (state: RootState) =>
  getGenericListState(state).metaData.loading;

export const getGenericListFilters = (state: RootState) =>
  getGenericListState(state).filters;

export const getGenericListFilterFields = createSelector(
  [getGenericListState],
  (genericListState) =>
    transformColumnsToFilterFields(genericListState.columns),
);
